import * as Yup from 'yup';

export const AddSoapNoteSchema = Yup.object().shape({
  purchaseCategory: Yup.string().nullable(true),
  noteS: Yup.string().nullable(true),
  noteO: Yup.string().nullable(true),
  noteA: Yup.string().nullable(true),
  noteP: Yup.string().nullable(true)
});
